import CTL_LoadingScreen from '@/compo/CTL_LoadingScreen';
import DefaultLayout from '@/layout/default';
import LayoutGameView from './GameView/LayoutGameView';
import routeGameViewSub from "./GameView/route";

export default [
  {
    path: '/game',
    HydrateFallback: () => <CTL_LoadingScreen/>,
    errorElement: <div>Error Page</div>,
    element:<DefaultLayout />,
    children:[
      { // 게임 목록
        index:true,
        lazy: async ()=>{
          //await delay(1000)
          const compo = await import('./Game');
          return{ Component:compo.default }
        },   
      },

      { // 게임 상세 정보
        path:':game_code',
        element:<LayoutGameView />,
        children:[...routeGameViewSub]        
      },

      
    ]

    //lazy: ()=>import('./index'),
    // Component: async()=>{
    //   return await import('./index');
    // }

    
  },
  
]


